import React from 'react';
import { Card, styled } from '@mui/material';

import type { CoverageSummaryProps } from './helpers/coverage-summary.utils';
import { useGetCoverageSummaryDeltas } from './CoverageSummary/UseGetCoverageSummaryDeltas';
import { CoverageSummaryGlobals } from './CoverageSummary/CoverageSummaryGlobals';
import { CoverageSummaryCoverages } from './CoverageSummary/CoverageSummaryCoverages';

export const CoverageSummary = ({
  policyDetails,
  progressData,
}: CoverageSummaryProps) => {
  const [showAllDetails, setShowAllDetails] = React.useState(false);

  const deltaData = useGetCoverageSummaryDeltas({
    policyDetails,
    progressData,
  });

  const hasCoverageDelta = Object.keys(deltaData.mergedCoveragesByGroups).some(
    (coverageGroup) =>
      deltaData.mergedCoveragesByGroups[coverageGroup].filter(
        (coverage) => coverage.isDelta
      ).length > 0
  );

  const handleShowAllDetails = () =>
    setShowAllDetails((prevState) => !prevState);

  return (
    <>
      <CoverageSummaryGlobals
        handleShowAllDetails={handleShowAllDetails}
        mergedGlobals={deltaData.mergedGlobals}
        showAllDetails={showAllDetails}
      />
      <CoverageSummaryCoverages
        mergedCoveragesByGroups={deltaData.mergedCoveragesByGroups}
        showAllDetails={showAllDetails}
        hasCoverageDelta={hasCoverageDelta}
      />
    </>
  );
};

export const DetailsCard = styled(Card)(({ theme: { palette } }) => ({
  backgroundColor: palette.background.default,
}));
